import { initializeApp } from 'firebase/app';

const firebaseConfig = {
	apiKey: 'AIzaSyBufFJOTsZ2y3Uh2ktFQNPj5K5IH5Re4pM',
	authDomain: 'personal-finance-manager-950db.firebaseapp.com',
	projectId: 'personal-finance-manager-950db',
	storageBucket: 'personal-finance-manager-950db.firebasestorage.app',
	messagingSenderId: '673414986780',
	appId: '1:673414986780:web:993228d342271bd342f3d9',
};

export const firebaseApp = initializeApp(firebaseConfig);
